import { useState } from "react";

import { TInputTag } from "components/InputMultipleTag";

import { queryGetUsersPipeline } from "@type/api/management";
import { useQueryWithCallbacks } from "lib/query/useQueryWithCallbacks";

import { TPipeline } from "@type/api/management/types";
import { LanguageType } from "types/index";

interface UseGetUsersPipelineProps {
  buId?: string;
  language: LanguageType;
}

export const useGetUsersPipeline = ({
  buId,
  language,
}: UseGetUsersPipelineProps) => {
  const [userPipelines, setUserPipelines] = useState<TPipeline[]>();
  const [userPipelineOptions, setUserPipelineOptions] = useState<TInputTag[]>();

  const { isLoading } = useQueryWithCallbacks({
    queryKey: queryGetUsersPipeline._key({ buId }, language),
    enabled: true,
    queryFn: () => queryGetUsersPipeline({ buId }, language),
    onSuccess: (res) => {
      const usePipelineOptions: TInputTag[] = res.data?.map(({ id, name }) => ({
        id,
        name,
      }));
      setUserPipelineOptions(usePipelineOptions);
      setUserPipelines(res.data);
    },
  });

  return {
    isLoadingUsersPipeline: isLoading,
    userPipelines,
    userPipelineOptions,
  };
};
